import React from 'react';

import PropTypes from 'prop-types';
import format from 'date-fns/format';
import Card from '@dnb/eufemia/components/card/Card';
import './status-message.css';
import { useTranslation } from 'react-i18next';
import FindLanguage from "../../i18n_custom";
import { isBankIDIncident } from '../../helpers';
import { Button } from '@dnb/eufemia';
import { chevron_right as ChevronRight } from '@dnb/eufemia/icons'
import { Grid } from '@dnb/eufemia'

const StatusMessage = ({ incident }) => {
  const { t } = useTranslation();
 const incidentsLocation = location.pathname === "/" 
    ? '/incidents' 
    : `${location.pathname}/incidents`;
  if (isBankIDIncident(incident)) {
    incident.incident_updates[0].body = "Leverandør jobber med saken.||Vendor is working to resolve the issue.";
  }
  console.log("Incident: ", incident);
  return (

    <Card className={`dnb-status-message dnb-status-message--${incident.impact}`} outline='none'>
      <Grid.Container columnGap='medium' style={{ alignItems: 'center' }} >
        <Grid.Item span={{
          small: 'full',
          medium: [1, 10],
          large: [1, 10]
        }}>
          <h1 className="dnb-heading-large">
            {/* {t('All our systems and services are working as normal')} */}
            {FindLanguage(incident.name)}
          </h1>
          <span className='dnb-no-statuses__last-updated'>
            {/* {t('Last updated')}: <time dateTime={lastUpdated}>{lastUpdated}</time> */}
            <time dateTime={format(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')}>
              {format(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')}
            </time>
          </span>
          <span className="dnb-status-message__time">
            {FindLanguage(incident.incident_updates[0].body)}
          </span>
        </Grid.Item>
        <Grid.Item span={{
          small: 'full',
          medium: [11, 'end'],
          large: [11, 'end']
        }}>
          <Button className='dnb-button-custom' text={t('See incidents')} variant="tertiary" href={incidentsLocation} target="_self" title={t('Go to the incident overview')} icon={ChevronRight} />
        </Grid.Item>
      </Grid.Container>



      {/* <span className={`dnb-status-icon dnb-status-icon--${incident.impact}`}>
          <Icon icon={getStatusIcon(incident.impact)} aria-hidden size="20" />
        </span> */}
      {/* <Button className='dnb-button-custom' text={t('See incidents')} variant="tertiary" href={incidents_location} target="_self" title={t('Go to the incident overview')} icon={ChevronRight} />

        <span className="dnb-status-message__text dnb-h--medium">{FindLanguage(incident.name)}</span>
        <span className="dnb-status-message__time">
          <time dateTime={format(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')}>
            {format(new Date(incident.started_at), 'dd.MM.yyyy, HH:mm')}
          </time>
        </span>
        <span className="dnb-status-message__time">
          {FindLanguage(incident.incident_updates[0].body)}
        </span> */}
    </Card>

  );
};

StatusMessage.propTypes = {
  incident: PropTypes.object,
};


export default StatusMessage;
